/**
 * Save Progress Passive Controller
 */
var nfSaveProgressPassiveController = Marionette.Object.extend({

    initialize: function( options ) {

        this.storage = window.localStorage;
        this.passiveForms = {};

        this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.onFormRendered );
        // Repeater set deletion updates the parent field's value via setAllRepeatersValues()
        // but never fires change:modelValue on any child, so onChangeModelValue never runs.
        // Listening to set:value here (which fires at the end of removeSet, after
        // setAllRepeatersValues has already updated the parent) fills that gap.
        this.listenTo( nfRadio.channel( 'field-repeater' ), 'set:value', this.onRepeaterValueChanged );
    },

    onFormRendered: function( formView ) {
        var formModel = formView.model;

        if( ! formModel.get( 'save_progress_passive_mode' ) ) return;

        var formInstanceID = formModel.get( 'id' );
        var formID = formInstanceID.toString().split('_')[0];

        this.passiveForms[ formID ] = formInstanceID;

        var formData = this.storage.getItem( 'nfForm-' + formID );

        Backbone.Radio.channel( 'forms' ).request( 'save:updateFieldsCollection',
            formModel.get( 'id' ),
            JSON.parse( formData )
        );

        this.listenTo( nfRadio.channel( 'fields' ), 'change:modelValue', this.onChangeModelValue );
        this.listenTo( nfRadio.channel( 'form-' + formInstanceID ), 'submit:response', function(){
            this.storage.removeItem( 'nfForm-' + formID );
        } );
    },

    onChangeModelValue: function( fieldModel ) {

        var formInstanceID  = fieldModel.get( 'formID' );
        var formID = formInstanceID.toString().split('_')[0];

        var name = 'nfForm-' + formID;


        var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formInstanceID );

        if( 'undefined' == typeof formModel ) return;
        if( ! formModel.get( 'save_progress_passive_mode' ) ) return;

        // var formData = this.cookie.get( name ) || {};
        // formData[ fieldModel.get( 'id' ) ] = fieldModel.get( 'value' );

        var fieldData = Backbone.Radio.channel( 'forms' ).request( 'save:fieldAttributes', formInstanceID );

        this.storage.setItem( name, JSON.stringify( fieldData ) );
    },

    onRepeaterValueChanged: function() {
        var self = this;
        // Defer to the next macrotask so setAllRepeatersValues() (which also listens
        // to set:value but was registered after us) has a chance to update the parent
        // repeater's value attribute before we read it via getfieldAttributes.
        setTimeout( function() {
            _.each( self.passiveForms, function( formInstanceID, formID ) {
                var formModel = Backbone.Radio.channel( 'app' ).request( 'get:form', formInstanceID );
                if ( 'undefined' === typeof formModel ) return;
                if ( ! formModel.get( 'save_progress_passive_mode' ) ) return;
                var fieldData = Backbone.Radio.channel( 'forms' ).request( 'save:fieldAttributes', formInstanceID );
                self.storage.setItem( 'nfForm-' + formID, JSON.stringify( fieldData ) );
            } );
        }, 0 );
    },

});
